export default "__VITE_PUBLIC_ASSET__89fed97a__"